"use strict";
// @ts-ignore
try {
    self['workbox:routing:6.1.2'] && _();
}
catch (e) { }
